import {defineStore} from 'pinia';

export const useAuthStore = defineStore('auth', {
    state: () => ({
        authToken: null,
        user: null
    }),
    actions: {
        login(token, user = false) {
            this.authToken = token;
            if (user) {
                this.user = user;
            }
        },
        logout() {
            this.authToken = null;
            this.user = null;
        },
    },
    getters: {
        isAuthenticated: (state) => !!state.authToken
    },
    persist: true
});
